window.showLoadingRow = function (elm, cs) {
  var loadingRow = `<tr id="loading-row"><td colspan="${cs}" class="text-center"><div class="spinner-border spinner-border-sm text-primary" role="status"></div></td></tr>`;
  $(`${elm} tbody`).html(loadingRow);
}

window.hideLoadingRow = function () {
  $('#loading-row').remove();
}

window.dtFinalTouch = function (option = null) {
  $('.dt-length').find('label').remove()
  $('.dt-search').find('label').remove()
  $('.dt-info').addClass("text-sm")
  $('.dt-layout-table').addClass('overflow-auto')
}

import './material_preparations'
import './ng_reports'
import './planning_products'
import './daily_reports'
import './idle_reports'
import './users'